module.exports = __webpack_public_path__ + "static/media/power_performance_comparative_per_subpark.39dc1690.svg";